<div *ngIf="visible" class="success-popup-overlay">
  <div class="success-popup">
    <div class="popup-header">
      <h3 class="popup-title">{{ '::DeliveryGift:ConfirmationComplete:Title' | abpLocalization }}</h3>
      <img class="close-button" (click)="close()" src="assets/images/icon/svg/close.svg" alt="" />
    </div>

    <div class="popup-content">
      <div class="success-icon">
        <i class="pi pi-check-circle"></i>
      </div>
      <div class="success-message">
        <h4 class="main-message">{{ '::DeliveryGift:ConfirmationComplete:MainMessage' | abpLocalization }}</h4>
        <p class="sub-message">{{ '::DeliveryGift:ConfirmationComplete:SubMessage' | abpLocalization }}</p>
      </div>
    </div>
  </div>
</div>


